import {DataObject} from "../dataObject";
import {SPIELER_FIELD_SETTINGS} from "./spielerFieldSettings";
import {SpielerPrivate} from "./spielerPrivate";
import store from "../../../store/store";
import SPIELER_CHANGE_HANDLER from "./spielerChangeHandler";
import SPIELER_MEMBERSHIP_HANDLER from "./spielerMembershipHandler";
import TimeStamp from "@/services/timeStamp";

export class Spieler extends DataObject {
    constructor(){
        super();
        this.setEmptyData();
    // local
        this.local.definitions.databaseHandlerCall = 'spieler';
        this.local.fieldSettings = SPIELER_FIELD_SETTINGS;
    }
    setEmptyData(){
        this.id = '';
    // table fields
        //this.lvNr = '';
        //this.vereinsNr = '';
        //this.passNr = '';
        this.nachname = '';
        this.vorname = '';
        this.titel ='';
        this.geschlecht = '';
        this.attest = '';
        this.dsv = '';
        this.ade = '';
        this.handicap = '';
        this.bemerkung = '';
        this.url = '';
        // new 2023
        this.nbcId = ''
    // private
        this.private = new SpielerPrivate();
    // technical fields: dates, verein, search, timestamps (not table or excel header needed)
        this.status = 'aktiv';
        this.sportart = '';
        this.dates = {
            anmeldeTag: '',     // '2018-07-07
            firstSportTag: '',  // '2018-07-01
            lastSportTag: '',   // '2033-06-30
            gesperrtAb: '',     // '2027-05-17  => Verwendung z.B. bei Todesfall
            akJahr: 0,
            akHJ: 0,
        };
        //this.lvVerein = {}; // 14101: { from: 2018-07-01, until: 2022-06-30, leihe: false, passNr: 141234 }
                            // 14103: { from: 2022-01-01, until: 2022-06-30, leihe: true, passNr: 148001 }
                            // 14103: { from: 2022-07-01, until: 2037-06-30, leihe: false, passNr: 141234 }
                            // neu: [ { lvVerein: 14101, from: 2022-07-01, until: 2037-06-30, leihe: false, passNr: 141234 }]
        this.memberships = [];
        this.search = {
            docs: '',
            lastAktiv: {},
            membershipYears: {},
            //lvVerein_year: {},  // ... Verwendung für Ergebnisdienst und Vereinsverwaltung
                                // ... auch die Leihe wird hier ohne Unterscheidung als Vollmitgliedschaft dargestellt
                                // 14101_2019_2020: true
                                // 14101_2020_2021: true
                                // 14101_2021_2022: true
                                // 14103_2021_2022: true
            leihen: {},  // ... Verwendung für Ergebnisdienst und Vereinsverwaltung
                                // 2021_2022: '14103'
                                // darauf wird gefiltert nach dem Load vom Server
            passNumbers: {}, // 141234: { from: 2018-07-01, until: 2021-12-31, leihe: false, verein: 14101 }
                        // 148003: { from: 2022-01-01, until: 2022-06-30, leihe: true, verein: 14103 }
                        //          => Duplikate möglich, wird jedes Jahr vergeben
                        // 142365: { from: 2022-07-01, until: 2037-06-30, leihe: false, verein: 14103 }
            passStatus: '', // 'beantragt', 'in Bearbeitung', '' => erledigt
            userUnique: '', // vorname '_' nachname '_' geburtsdatum
        };
        // Timestamps
        this.letzteAenderung = null;
    // new 2023 ts & passprint
        this.ts = 0;
        this.tsLastPassPrint = 0;
        this.tsLastPlayerPassPrint = 0;
        this.waitingForPassPrint = false;
        this.waitingForPlayerPassPrint = false;
        this.printIsDuplikat = false;
        this.roles = {}
    }

// super override
    getDbObject(){
        let data = super.getDbObject();
        delete data.private;
        return data;
    }

    setTechnicalDataForNewSpieler(lv, vereinsNr, sportJahr){
        if ( !this.id  ) {
            this.ts = TimeStamp.getGMTTimestamp();
            this.sportart = lv.sportart;
            let lvVerein = lv.id + '' + vereinsNr;
            let validityRange = SPIELER_CHANGE_HANDLER.getPassValidityRange(this.private.geburtsdatum, lv.sportart, sportJahr);
            this.memberships = SPIELER_MEMBERSHIP_HANDLER.createNewSpieler(lvVerein, validityRange.from, validityRange.until);
            this.status = 'aktiv';
            this.search = SPIELER_CHANGE_HANDLER.search_setPassStatus(this.search, 'beantragt');
            this.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( this.search, this.memberships, this.status );
            this.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus( this.search, this.ade, this.dsv, this.status );
            this.dates = SPIELER_CHANGE_HANDLER.dates_update(this); // anmeldetag is changed directly, this is only for first and last sporttag
        } else if (this.private.local.documentUpdates.geburtsdatum && this.search.passStatus === 'beantragt') {
            let validityRange = SPIELER_CHANGE_HANDLER.getPassValidityRange(this.private.local.documentUpdates.geburtsdatum,
                lv.sportart, sportJahr);
            this.local.documentUpdates.memberships = JSON.parse(JSON.stringify(this.memberships));
            this.local.documentUpdates.memberships[0].until = validityRange.until;
            this.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( this.search,
                                                this.local.documentUpdates.memberships, this.status );
            this.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus( this.search, this.ade, this.dsv, this.status );
            this.dates = SPIELER_CHANGE_HANDLER.dates_update(this);
            this.local.documentUpdates.dates = this.dates;
            this.local.documentUpdates.dates.lastSportTag = validityRange.until;
        } else if (this.private.local.documentUpdates.geburtsdatum) { //
            this.local.documentUpdates.dates = this.dates
            this.local.documentUpdates.dates.akJahr = parseInt(this.private.local.documentUpdates.geburtsdatum.substring(0,4));
            this.local.documentUpdates.dates.akHJ = parseInt(this.private.local.documentUpdates.geburtsdatum.substring(5,7)) <= 6 ? 1 : 2;
        }
    // very new
        this.search = SPIELER_CHANGE_HANDLER.search_setUserUnique(this.search, this )
    }

    formatData() {
        this.nachname = this.nachname.toUpperCase();
    }
    trimStrings(){
        this.vorname = this.vorname.trim();
        this.nachname = this.nachname.trim();
        this.private.strasse = this.private.strasse.trim();
        this.private.ort = this.private.ort.trim();
        this.private.geburtsort = this.private.geburtsort.trim();
    }
    nachnameUpdateToUpperCase(fieldName){
        if(fieldName === 'nachname') {
            this.local.documentUpdates.nachname = this.local.documentUpdates.nachname.toUpperCase();
        }
    }

    getTableHeaders(columnListName){
        let columnList = [];
        switch (columnListName) {
            case 'landesverband':
                columnList = ['passNr', 'nachname', 'vorname', 'statusDisplay', 'letzteAenderung'];
                break;
            case 'search':
                columnList = ['lvId', 'vereinId', 'passNr', 'nachname', 'vorname', 'statusDisplay', 'letzteAenderung'];
                break;
            case 'leihspieler':
                columnList = ['vereinId', 'passNr', 'nachname', 'vorname', 'statusDisplay', 'leihPassNr'];
                break;
        }
        return this.getTableHeaderList(columnList)
    }
        getTableHeaderList(columnList){
            let headerList = [];
            columnList.forEach( (column) => {
                const settings = this.local.fieldSettings[column];
                headerList.push({
                    text: settings.app,
                    value: settings.childOf ? [settings.childOf] + '.' + column : column,
                    sortable: true
                })
            });
            return headerList;
        }

    getFieldListEdit(action){
        let fieldList = [];
        switch (action) {
            case 'addPlayer':
            case 'editNew':
                fieldList = ['titel', 'vorname', 'nachname', 'geschlecht', 'plz',
                    'ort', 'strasse', 'eMail', 'mobilTelefon', 'telefon', 'geburtsdatum',
                    'geburtsort', 'nationalitaet', 'dsv',
                    'attest', 'ade', 'anmeldeTag', 'nbcId', 'handicap', 'bemerkung'
                ];
                break;
            case 'info':
                fieldList = ['titel', 'vorname', 'nachname', 'geschlecht', 'ak', 'plz',
                    'ort', 'strasse', 'eMail', 'mobilTelefon', 'telefon', 'geburtsdatum',
                    'geburtsort', 'nationalitaet', 'dsv',
                    'attest', 'ade', 'anmeldeTag', 'nbcId', 'handicap', 'bemerkung'
                ];
                break;
            case 'edit':
                fieldList = ['titel', 'vorname', 'nachname', 'geschlecht', 'plz',
                    'ort', 'strasse', 'eMail', 'telefon', 'mobilTelefon', 'geburtsdatum',
                    'geburtsort', 'nationalitaet', 'nbcId', 'handicap', 'bemerkung'
                ]; //'geburtsdatum',
                break;
            case 'bestaetigungen':
                fieldList = [ 'dsv', 'attest', 'ade' ];
                break;
        }
        return this.getFieldList(fieldList);
    }
        getFieldList(fieldList){
            let fieldSettingsList = [];
            fieldList.forEach( (field) => {
                let fieldObject = this.local.fieldSettings[field];
                fieldObject.id = field;
                fieldSettingsList.push( fieldObject );
            });
            return fieldSettingsList;
        }

    async setCurrentData(data){
        if ( data ) {
            this.setFromDataObject(data);
            this.setPrivateDataFromDB();
            /*let dataPrivate = await store.dispatch('getTempSnapshot', privateDocParams);
            console.log ("dataPrivate", dataPrivate);
            if ( dataPrivate.successful ) {
                this.private.setFromDataObject(dataPrivate.content)
            }*/
        }
    }
        async setPrivateDataFromDB(){
            const privateDocParams = {
                collection: 'spieler/' + this.id + '/private',
                docId: this.id
            };
            let dataPrivate = await store.dispatch('getTempSnapshot', privateDocParams);
            console.log ("dataPrivate", dataPrivate);
            if ( dataPrivate.successful ) {
                this.private.setFromDataObject(dataPrivate.content)
            }
        }

}

